<section class="section-conteneur">
  <div class="card-conteneur" fxLayout="row wrap" fxLayoutGap="20px grid" fxLayoutAlign="center space-evenly stretch">
    <div *ngIf="hasSupervisionGrant">
      <app-dashboard-item-card [counter]="dashboard?.RejectedInvoices" icon="report_problem" description="Factures en rejet" bodyCssClass="bg-color-orange" footerCssClass="bg-color-darkorange"
        detailUrl='/invoices/rejected'>
      </app-dashboard-item-card>
    </div>

    <div *ngIf="hasOperationalGrant">
      <app-dashboard-item-card [counter]="dashboard?.DispatchedInvoices" icon="pending_actions" description="Factures à traiter" detailUrl='/invoices/dispatched'>
      </app-dashboard-item-card>
    </div>

    <div *ngIf="hasControlGrant || hasControlGrantNotPPR || hasOperationalGrant || hasOperationContributorGrant">
      <app-dashboard-item-card [counter]="dashboard?.WaitingInvoices" icon="hourglass_top" description="Factures en attente" detailUrl='/invoices/waiting-voucher'>
      </app-dashboard-item-card>
    </div>

    <div *ngIf="hasValidationGrant">
      <app-dashboard-item-card [counter]="dashboard?.ProcessedVouchers" icon="how_to_reg" description="Factures à valider" detailUrl='/invoices/voucherworkflow'>
      </app-dashboard-item-card>
    </div>

    <div *ngIf="hasPPRValidationGrant">
      <app-dashboard-item-card [counter]="dashboard?.ProcessedPromotionInvoices" icon="how_to_reg" description="Factures à valider Promotion" detailUrl='/invoices/promotionworkflow'>
      </app-dashboard-item-card>
    </div>

    <div *ngIf="hasNonErpGrant">
      <app-dashboard-item-card [counter]="dashboard?.WorkflowCompletedVouchers" icon="calculate" description="Factures à comptabiliser" detailUrl='/invoices/vouchervalidated'>
      </app-dashboard-item-card>
    </div>

    <div *ngIf="hasControlGrantNotPPR">
      <app-dashboard-item-card [counter]="dashboard?.UncheckedInvoices" icon="assignment_turned_in" description="Factures à contrôler" detailUrl='/invoices/control'>
      </app-dashboard-item-card>
    </div>

    <div *ngIf="hasAnalyticalGrant">
      <app-dashboard-item-card [counter]="dashboard?.ImportMissingInvoiceNumbers" icon="manage_search" description="Documents à analyser" bodyCssClass="bg-color-orange"
        footerCssClass="bg-color-darkorange" detailUrl='/analysis/missing-invoice-numbers'>
      </app-dashboard-item-card>
    </div>

    <div *ngIf="hasAdministrationGrant">
      <app-dashboard-item-card [counter]="dashboard?.FaultedInvoices" icon="error" description="Factures en anomalie" bodyCssClass="bg-color-orange" footerCssClass="bg-color-darkorange"
        detailUrl='/administration/faulted-invoice'>
      </app-dashboard-item-card>
    </div>
  </div>
</section>

<div class="footerTitles">
  <div class="help">
    Lien vers les supports de formation : <a href="{{academie}}" target="_blank">E-Fac</a>
  </div>

  <div class="version">
    &copy; ALTAREA - v{{version}}
  </div>
</div>
